import Program from 'utils/program';
import { ProgramEnum } from '../types/general';

export const isResetProgram = (): boolean =>
  Program.get() === ProgramEnum.RESET;
export const isResetOProgram = (): boolean =>
  Program.get() === ProgramEnum.RESET_O;
export const isPear002aProgram = (): boolean =>
  Program.get() === ProgramEnum.PEAR_002A;

export const showBupUseLabelsInUI = (
  patient?: Nullable<IPatientDetails>,
): boolean => {
  let showBupUse = isResetOProgram() || isPear002aProgram();
  if (isPear002aProgram()) {
    const featureGroupName =
      (patient!.prescriptions!.length > 0 &&
        patient!.prescriptions![0].featureGroupName) ||
      '';
    if (featureGroupName.includes('Monthly')) {
      showBupUse = false;
    }
  }
  return showBupUse;
};
